<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="contact" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="page-content">
        <h1>Contact Us</h1>
        <p>We welcome your questions, feedback, and inquiries. Please reach out to us using the information below.</p>
        
        <h2>Get in Touch</h2>
        <p>For general inquiries, support requests, or partnership opportunities, please contact us.</p>
        
        <h2>Frequently Asked Questions</h2>
        <div class="faq-section">
          <h3>How can I download GBWhatsApp?</h3>
          <p>Simply click the download button on our homepage or visit the download page.</p>
          
          <h3>Is GBWhatsApp safe to use?</h3>
          <p>Yes, GBWhatsApp includes anti-ban protection. However, as with any mod app, there is a small risk.</p>
          
          <h3>Can I transfer my chat history?</h3>
          <p>Yes, you can restore your chat backup when setting up GBWhatsApp.</p>
        </div>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Contact',
  components: { HeadNav },
};
</script>

<style lang="scss" scoped>
.page-content {
  max-width: 1080px;
  margin: 2rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  h1 { color: #25D366; font-size: 2.5em; margin-bottom: 30px; text-align: center; }
  h2 { color: #25D366; font-size: 1.8em; margin: 30px 0 20px; }
  h3 { color: #128C7E; font-size: 1.2em; margin: 20px 0 10px; }
  p { line-height: 1.8; font-size: 16px; color: #444; word-break: break-word; }
}

@media (max-width: 768px) {
  .page-content {
    padding: 20px 15px;
    h1 { font-size: 2em; }
    h2 { font-size: 1.4em; }
    h3 { font-size: 1.1em; }
    p { font-size: 15px; }
  }
}
</style>
